import { render } from "./LongTermPlanView.vue?vue&type=template&id=044d64de&scoped=true"
import script from "./LongTermPlanView.vue?vue&type=script&lang=js"
export * from "./LongTermPlanView.vue?vue&type=script&lang=js"

import "./LongTermPlanView.vue?vue&type=style&index=0&id=044d64de&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044d64de"]])

export default __exports__